<it-header
  [loginStyle]="'none'"
  [light]="'false'"
  [showSearch]="'false'"
  [sticky]="true"
  [megamenu]="false"
>
  <ul *ngIf="contextService.getSelected('cot')?.name" class="link-list" slimLinkList>
    <li>
      <a class="list-item" href="#" (click)="goToContext($event)" aria-current="page">COT: {{ contextService.getSelected('cot')?.name }}</a>
    </li>
  </ul>

  <ul *ngIf="contextService.getSelected('ward')?.name" class="link-list" slimLinkList>
    <li>
      <a class="list-item" href="#" (click)="goToContext($event)" aria-current="page">{{ contextService.getSelected('ward')?.name }}</a>
    </li>
  </ul>

  <ul *ngIf="contextService.getSelected('mmg')?.name" class="link-list" slimLinkList>
    <li>
      <a class="list-item" href="#" (click)="goToContext($event)" aria-current="page">{{ contextService.getSelected('mmg')?.name }}</a>
    </li>
  </ul>

  <ul *ngIf="contextService.getSelected('uvm')?.name" class="link-list" slimLinkList>
    <li>
      <a class="list-item" href="#" (click)="goToContext($event)" aria-current="page">{{ contextService.getSelected('uvm')?.name }}</a>
    </li>
  </ul>

  <ul *ngIf="contextService.getSelected('pua')?.name" class="link-list" slimLinkList>
    <li>
      <a class="list-item" href="#" (click)="goToContext($event)" aria-current="page">{{ contextService.getSelected('pua')?.name }}</a>
    </li>
  </ul>

  <ul *ngIf="contextService.getSelected('bm')?.name" class="link-list" slimLinkList>
    <li>
      <a class="list-item" href="#" (click)="goToContext($event)" aria-current="page">{{ contextService.getSelected('bm')?.name }}</a>
    </li>
  </ul>
  
  <ng-container slimRightZone *ngIf="authService.isLoggedIn && authService.userInfo">
    <it-dropdown mode="nav">
      <span button> Benvenuto: {{ authService.userInfo.name }}</span>
      <ng-container list>
        <it-dropdown-item *ngIf="authService.isOperatoreUvm">
          Profilo: Valutatore UVM
        </it-dropdown-item>
        <it-dropdown-item *ngIf="authService.isOperatoreUvcp">
          Profilo: Valutatore UVCP
        </it-dropdown-item>
        <it-dropdown-item *ngIf="authService.isOperatoreCot">
          Profilo: Gestore COT
        </it-dropdown-item>
        <it-dropdown-item *ngIf="authService.isOperatoreSegnalante">
          Profilo: Segnalante
        </it-dropdown-item>
        <it-dropdown-item *ngIf="authService.isOperatoreMmg">
          Profilo: MMG
        </it-dropdown-item>
        <it-dropdown-item *ngIf="authService.isOperatorePua">
          Profilo: PUA
        </it-dropdown-item>
        <it-dropdown-item *ngIf="authService.isOperatoreBM">
          Profilo: Bed Manager
        </it-dropdown-item>
        <!-- <it-dropdown-item
          >ASL: {{ contextService.get.name }}
        </it-dropdown-item> -->
        <it-dropdown-item (click)="logout()">Logout</it-dropdown-item>
      </ng-container>
    </it-dropdown>
  </ng-container>

  <ng-container brand>
    <a>
      <img
        src="assets/images/logo.png"
        alt="Logo"
        style="height: 70px; width: auto"
        class="me-3 d-none d-md-block"
      />
      <div class="it-brand-text">
        <div class="it-brand-title">
          PIATTAFORMA REGIONALE GESTIONE PERCORSI DI CURA
        </div>
        <div class="it-brand-tagline d-none d-md-block">
          Gestione delle richieste di transizione
        </div>
      </div>
    </a>
  </ng-container>
  <ng-container navItems *ngIf="authService.isLoggedIn && authService.isOperatoreMmg">
    <it-navbar-item>
      <a
        class="nav-link"
        routerLink="/dashboard-mmg"
        routerLinkActive="active"
        aria-current="page"
        ><span>Dashboard</span></a
      >
    </it-navbar-item>
  </ng-container>
  <ng-container navItems *ngIf="authService.isLoggedIn && !authService.isOperatoreMmg">
    <it-navbar-item>
      <a
        class="nav-link"
        routerLink="/dashboard"
        routerLinkActive="active"
        aria-current="page"
        ><span>Dashboard</span></a
      >
    </it-navbar-item>
    <it-navbar-item>
      <a
        class="nav-link"
        routerLink="/request-list"
        routerLinkActive="active"
        aria-disabled="true"
        ><span>Elenco Richieste</span></a
      >
    </it-navbar-item>
    <it-navbar-item *ngIf="!authService.isOperatoreUvm && !authService.isOperatoreUvcp && !authService.isOperatoreSuperUser">
      <a
        class="nav-link"
        routerLink="/request-new"
        routerLinkActive="active"
        aria-disabled="true"
        ><span>Nuova Richiesta</span></a
      >
    </it-navbar-item>
    <it-navbar-item *ngIf="true">
      <a
        class="nav-link"
        routerLink="/statistics"
        routerLinkActive="active"
        aria-disabled="true"
        ><span>Statistiche</span></a
      >
    </it-navbar-item>
    <it-navbar-item *ngIf="true">
      <a
        class="nav-link"
        routerLink="/models"
        routerLinkActive="active"
        aria-disabled="true"
        ><span>Modelli</span></a
      >
    </it-navbar-item>
    <it-navbar-item *ngIf="true">
      <a
        class="nav-link"
        routerLink="/monitor"
        routerLinkActive="active"
        aria-disabled="true"
        ><span>Monitor</span></a
      >
    </it-navbar-item>
    <!-- <it-navbar-item>
          <it-dropdown mode="nav">
            <span button>Menu dropdown</span>
            <ng-container list>
              <it-dropdown-item>Link lista 1</it-dropdown-item>
              <it-dropdown-item>Link lista 2</it-dropdown-item>
            </ng-container>
          </it-dropdown>
        </it-navbar-item> -->
  </ng-container>
</it-header>